import { useEffect } from 'react';
import { useMatch, useNavigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '@store';
import { PermissionDenied, PermissionEnum } from '@ui/src';

import ROUTES from '../../../routes';

import cn from './styles.module.css';

const ReportsSettings = () => {
  const { activePermissions } = useAppSelector((state) => state.root);

  const match = useMatch(ROUTES.REPORTS_SETTINGS);

  const navigate = useNavigate();

  useEffect(() => {
    if (
      match &&
      activePermissions?.includes(
        PermissionEnum.SETTINGS_REGULATORY_REPORT_FINTRAC_EDIT_ACTION,
      )
    ) {
      navigate(ROUTES.REPORTS_SETTINGS_FINTRAC);
    }
  }, [activePermissions, match]);

  let content;

  if (
    !activePermissions?.includes(
      PermissionEnum.SETTINGS_REGULATORY_REPORT_FINTRAC_EDIT_ACTION,
    )
  ) {
    content = <PermissionDenied />;
  } else {
    content = (
      <>
        <div className={cn.reportsSettingsTitle}>Report settings</div>
        <Outlet />
      </>
    );
  }

  return <div className={cn.reportSettings}>{content}</div>;
};

export default ReportsSettings;
